export default function createCompanyForLeadData({
  companyId,
  companyName,
  withoutPs,
  equipmentList,
  productionSites
}) {
  let ps = [];
  if (withoutPs)
    ps = [
      {
        id: "id-stub-sm",
        name: "name-stub-sm",
        eq: equipmentList
      }
    ];
  else ps = productionSites;

  return {
    companyId,
    companyName,
    ps: ps
  };
}
